var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "options" }, [
      _c(
        "div",
        {
          ref: "optionsList",
          staticClass: "list gantt_scroll",
          style: { maxHeight: _vm.maxHeight + "px" },
        },
        [
          _c(
            "Container",
            {
              attrs: {
                "drag-handle-selector": ".option-drag-handle",
                "lock-axis": "y",
                "auto-scroll-enabled": true,
              },
              on: {
                drop: function ($event) {
                  return _vm.onDrop(null, _vm.optionsItems, $event)
                },
              },
            },
            _vm._l(_vm.optionsItems, function (item, index) {
              return _c(
                "Draggable",
                {
                  key: index,
                  class: [
                    "list__item",
                    !item.readonly ? "active" : "",
                    _vm.error && index === 0 ? "is_error" : "",
                  ],
                },
                [
                  _vm.optionsItems.length > 1
                    ? _c(
                        "div",
                        { staticClass: "dnd_icon option-drag-handle" },
                        [
                          _c("svg-sprite", {
                            attrs: { name: "dragdrop", size: 20 },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "option_input",
                        item.readonly && _vm.optionsItems.length > 1
                          ? "option-drag-handle"
                          : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.clickEdit(item.id)
                        },
                      },
                    },
                    [
                      _c("vgp-input", {
                        ref: "optionInput",
                        refInFor: true,
                        attrs: {
                          "data-id": item.id,
                          placeholder: _vm.locale(
                            "custom_column_item_placeholder"
                          ),
                          value: item.value,
                          border: false,
                          small: true,
                          "change-by-enter": true,
                          "use-tab-key": true,
                        },
                        on: {
                          onChange: function ($event) {
                            return _vm.onChangeInput($event, item.id)
                          },
                          input: function ($event) {
                            return _vm.onChangeInput($event, item.id)
                          },
                          onKeyup: _vm.addOptionByEnter,
                          onKeydown: function ($event) {
                            return _vm.onKeydown($event, item)
                          },
                          onBlur: function ($event) {
                            return _vm.onChangeInput($event, item.id)
                          },
                          onFocus: function ($event) {
                            return _vm.$emit("resetError")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons" }, [
                    _vm.optionsItems.length > 1
                      ? _c(
                          "div",
                          { staticClass: "buttons__delete" },
                          [
                            _c("icon-button", {
                              attrs: {
                                icon: { name: "delete", size: 20 },
                                size: "small",
                              },
                              on: {
                                onClick: function ($event) {
                                  return _vm.deleteOption(item.id)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button_add" },
        [
          _c("vgp-button", {
            staticClass: "gp_autotest_columns_bar_add_multiselect_option",
            attrs: {
              label: _vm.locale("common_add"),
              type: "text",
              icon: { name: "plus-1", type: "bold", size: 20 },
              "icon-side": "left",
              "x-small": true,
            },
            on: { onClick: _vm.addOption },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }